<div class="overlay-wrapper" *ngIf="isLoading">
  <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">
  <div class="content container">
      <div>
          <nav aria-label="breadcrumb">
              <ol id="w6" class="breadcrumb">
                  <li class="breadcrumb-item"><a routerLink="/{{mainPath}}/Dashboard">{{'home'|translate}}</a></li>
                  <li class="breadcrumb-item active" aria-current="page">الجمارك</li>
              </ol>
          </nav>
      </div>
  </div>

  <div class="row justify-content-center py-7" style="background:url(/img/bg-green-full.png);">
      <div class="col-md-12 col-12">

          <div class="js-step-form">
              <div id="basicStepFormContent">
                  <div id="basicStepDetails" class="card">
                      <div>
                          <div class="card-header">
                              <h3 class="card-title h3">
                                  الجمارك
                              </h3>
                          </div>

                          <div class="card-body">
                              <form [formGroup]="form" (ngSubmit)="onSubmit()">

                                  <div class="row">
                                      <div class="col-md-4 form-group py-2">
                                          <label for="taxNumber" class="pb-2">الرقم الضريبي:</label>
                                          <input type="text" id="taxNumber" formControlName="taxNumber" class="form-control" readonly>
                                          <div *ngIf="form.get('taxNumber')?.invalid && formSubmited" class="text-danger">
                                              حقل اجباري
                                          </div>
                                      </div>
                                  </div>

                                  <hr>

                                  <div class="row align-items-center">
                                      <div class="col-md-4 form-group py-2">
                                          <label for="licenseId" class="pb-2">رقم الرخصة:</label>
                                          <input type="text" id="licenseId" formControlName="licenseId" class="form-control">
                                          <div *ngIf="(form.get('licenseId')?.invalid && formSubmited) || showLicenseError" class="text-danger">
                                              حقل اجباري
                                          </div>
                                      </div>
                                  </div>

                                  <hr>

                                  <ng-container *ngIf="showJamarek">
                                      <div class="row">
                                          <div class="col-12">
                                              <p>
                                                  العناصر المستوردة
                                              </p>
                                          </div>
                                      </div>

                                      <div style="overflow-x: auto;" formArrayName="formItems">
                                        <table class="table table-bordered table-striped table-responsive" style="width: 150%;">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>العنصر</th>
                                                    <th>اسم العنصر</th>
                                                    <th>hs code</th>
                                                    <th>الكمية</th>
                                                    <th>وحدة القياس</th>
                                                    <th>قائمة الموجودات المعفاة</th>
                                                    <th>رمز الاعفاء</th>
                                                    <th>الارصدة</th>
                                                    <th>القيمة بالدينار للقطعة الواحدة</th>
                                                    <th>مجموع القيمة بالدينار</th>
                                                    <th colspan="3">الوصف</th>
                                                    <th colspan="3">ملاحظات الموظف</th>
                                                    <th>حذف</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of Items.controls; let i = index" [formGroupName]="i">

                                                    <input type="hidden" formControlName="id">

                                                    <td>
                                                      {{i+1}}
                                                    </td>
                                                    <td>
                                                        <select id="unitId-{{i}}" formControlName="unitId" class="form-control" (change)="onUnitIdChange($event, i)">
                                                            <option value="">يرجى الاختيار</option>
                                                            <option value="{{unit.key}}" *ngFor="let unit of units[i]">{{unit.value}}</option>
                                                        </select>
                                                        <div *ngIf="item.get('unitId')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="text" id="unitName-{{i}}" formControlName="unitName" class="form-control">
                                                        <div *ngIf="item.get('unitName')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="text" id="hsCode-{{i}}" formControlName="hsCode" readonly class="form-control">
                                                        <div *ngIf="item.get('hsCode')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="quantity-{{i}}" formControlName="quantity" class="form-control" (change)="calculateCounter()">
                                                        <div *ngIf="item?.get('quantity')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                        <div *ngIf="item?.get('quantity')?.errors?.min && formSubmited" class="text-danger">
                                                            يجب ان تكون الكمية اكبر من 0
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <select id="staticUnit-{{i}}" formControlName="staticUnit" class="form-control">
                                                            <option value="">يرجى الاختيار</option>
                                                            <option value="{{unit.key}}" *ngFor="let unit of statisticalUnits">{{unit.value}}</option>
                                                        </select>
                                                        <div *ngIf="item.get('staticUnit')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p-dropdown [options]="exemptAssetsList" id="exemptAssets-{{i}}" formControlName="exemptAssets" optionValue="key" [filter]="true" filterBy="key" [showClear]="false" placeholder="يرجى الاختيار">
                                                            <ng-template pTemplate="selectedItem">
                                                                <div class="flex align-items-center gap-2" *ngIf="item.get('exemptAssets')?.value!='' ">
                                                                    <div>{{ item.get('exemptAssets')?.value }}</div>
                                                                </div>
                                                            </ng-template>
                                                            <ng-template let-item pTemplate="item">
                                                                <div class="flex align-items-center gap-2">
                                                                    <div>{{ item.value }}</div>
                                                                </div>
                                                            </ng-template>
                                                        </p-dropdown>
                                                        <div *ngIf="item.get('exemptAssets')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="additionalCode-{{i}}" formControlName="additionalCode" class="form-control">
                                                        <div *ngIf="item.get('additionalCode')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="credits-{{i}}" formControlName="credits" class="form-control">
                                                        <div *ngIf="item.get('credits')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="totalPrice-{{i}}" formControlName="totalPrice" class="form-control" (change)="calculateCounter()">
                                                        <div *ngIf="item?.get('totalPrice')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                        <div *ngIf="item?.get('totalPrice')?.errors?.min && formSubmited" class="text-danger">
                                                            يجب ان يكون السعر اكبر من 0
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" value="{{item?.get('totalPrice')?.value * item?.get('quantity')?.value}}" readonly class="form-control">
                                                    </td>
                                                    <td colspan="3">
                                                        <textarea id="description-{{i}}" formControlName="description" class="form-control"></textarea>
                                                        <div *ngIf="item?.get('description')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td colspan="3">
                                                        <textarea id="note-{{i}}" formControlName="note" class="form-control"></textarea>
                                                    </td>
                                                    <td *ngIf="!isEmployee">
                                                        <i role="button" (click)="removeJamarek(i)" class="fa-solid fa-trash text-danger p-2" style="padding: 7px; border: 2px solid #eee; border-radius: 5px;"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                      </div>

                                      <hr>
                                  </ng-container>

                                  <ng-container *ngIf="showTax">
                                      <div class="row">
                                          <div class="col-12">
                                              <p>
                                                  العناصر المحلية
                                              </p>
                                          </div>
                                      </div>

                                      <div style="overflow-x: auto;" formArrayName="taxItems">
                                        <table class="table table-bordered table-striped table-responsive" style="width: 150%;">
                                            <thead>
                                                <tr>
                                                    <th>اسم العنصر</th>
                                                    <th>الكمية</th>
                                                    <th>القيمة بالدينار للقطعة الواحدة</th>
                                                    <th>وحدة القياس</th>
                                                    <th>قائمة الموجودات المعفاة</th>
                                                    <th>رمز الاعفاء</th>
                                                    <th>الارصدة</th>
                                                    <th>مجموع القيمة بالدينار</th>
                                                    <th colspan="3">الوصف</th>
                                                    <th colspan="3">ملاحظات الموظف</th>
                                                    <th>حذف</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of TaxItems.controls; let i = index" [formGroupName]="i">

                                                    <input type="hidden" formControlName="id">
  
                                                    <input type="hidden" formControlName="hsCode" value="1">
                                                    <input type="hidden" formControlName="unitId" value="1">
                                                    
                                                    <td>
                                                      {{i+1}}
                                                    </td>
                                                    <td>
                                                        <input type="text" id="unitName-{{i}}" formControlName="unitName" class="form-control">
                                                        <div *ngIf="item.get('unitName')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="quantity-{{i}}" formControlName="quantity" class="form-control" (change)="calculateCounter()">
                                                        <div *ngIf="item?.get('quantity')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                        <div *ngIf="item?.get('quantity')?.errors?.min && formSubmited" class="text-danger">
                                                            يجب ان تكون الكمية اكبر من 0
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="totalPrice-{{i}}" formControlName="totalPrice" class="form-control" (change)="calculateCounter()">
                                                        <div *ngIf="item?.get('totalPrice')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                        <div *ngIf="item?.get('totalPrice')?.errors?.min && formSubmited" class="text-danger">
                                                            يجب ان يكون السعر اكبر من 0
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <select id="staticUnit-{{i}}" formControlName="staticUnit" class="form-control">
                                                            <option value="">يرجى الاختيار</option>
                                                            <option value="{{unit.key}}" *ngFor="let unit of statisticalUnits">{{unit.value}}</option>
                                                        </select>
                                                        <div *ngIf="item.get('staticUnit')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p-dropdown [options]="exemptAssetsList" id="exemptAssets-{{i}}" formControlName="exemptAssets" optionValue="key" [filter]="true" filterBy="key" [showClear]="false" placeholder="يرجى الاختيار">
                                                            <ng-template pTemplate="selectedItem">
                                                                <div class="flex align-items-center gap-2" *ngIf="item.get('exemptAssets')?.value!='' ">
                                                                    <div>{{ item.get('exemptAssets')?.value }}</div>
                                                                </div>
                                                            </ng-template>
                                                            <ng-template let-item pTemplate="item">
                                                                <div class="flex align-items-center gap-2">
                                                                    <div>{{ item.value }}</div>
                                                                </div>
                                                            </ng-template>
                                                        </p-dropdown>
                                                        <div *ngIf="item.get('exemptAssets')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="additionalCode-{{i}}" formControlName="additionalCode" class="form-control">
                                                        <div *ngIf="item.get('additionalCode')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" id="credits-{{i}}" formControlName="credits" class="form-control">
                                                        <div *ngIf="item.get('credits')?.invalid && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" value="{{item?.get('totalPrice')?.value * item?.get('quantity')?.value}}" readonly class="form-control">
                                                    </td>
                                                    <td colspan="3">
                                                        <textarea id="description-{{i}}" formControlName="description" class="form-control"></textarea>
                                                        <div *ngIf="item?.get('description')?.errors?.required && formSubmited" class="text-danger">
                                                            حقل اجباري
                                                        </div>
                                                    </td>
                                                    <td colspan="3">
                                                        <textarea id="note-{{i}}" formControlName="note" class="form-control"></textarea>
                                                    </td>
                                                    <td *ngIf="!isEmployee">
                                                        <i role="button" (click)="removeTax(i)" class="fa-solid fa-trash text-danger p-2" style="padding: 7px; border: 2px solid #eee; border-radius: 5px;"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                      </div>


                                      <hr>
                                  </ng-container>

                                  <div class="row">
                                      <div class="col-5">
                                          المبلغ الاجمالي للعناصر المستوردة
                                      </div>

                                      <div class="col-7">
                                          {{gamarekCount}} دينار
                                      </div>

                                      <div class="col-5">
                                          المبلغ الاجمالي للعناصر المحلية
                                      </div>

                                      <div class="col-7">
                                          {{taxCount}} دينار
                                      </div>

                                      <div class="col-5">
                                          المبلغ الاجمالي كامل
                                      </div>

                                      <div class="col-7">
                                          {{gamarekCount + taxCount}} دينار
                                      </div>
                                  </div>

                                  <hr>

                                  <div class="row" *ngIf="showSaveBtn && !isEmployee">
                                      <div class="col-12" style="text-align: center;">
                                          <button type="submit" class="btn btn-primary">حفظ</button>
                                      </div>
                                  </div>

                              </form>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</main>